import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { TProgramCategories } from '../types';

export const getProgramsCategories = async (): Promise<TProgramCategories[]> => {
  return mediaManagerClient.get('/api/v1/program_categories').then(({ data }) => data);
};
type QueryFnType = typeof getProgramsCategories;

type UseProgramsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetProgramsCategories = ({ config }: UseProgramsOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['program-categories'],
    queryFn: getProgramsCategories,
  });
};
